export default "__VITE_ASSET__BU6OfqrW__"